import { PureComponent } from 'react'
import styled from 'glamorous'
import { withRouter } from 'react-router-dom'
import Route from 'react-router-dom/Route'
import Switch from 'react-router-dom/Switch'

import { $ } from 'utils'
import VerificationResults from 'components/panels/VerificationResults'
import { MatchingPerson, MatchingFace, IdentifyPerson, IdentifyFace } from 'components/panels/MatchingResults'

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  margin: 'auto',
})

const InnerContainer = styled.div({
  width: 1152,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
})

const Header = styled.div({
  width: '100%',
  marginBottom: 24
})

const Columns = styled.div({
  width: '100%',
  flex: 1,
  display: 'flex',
})

const LeftColumn = styled.div({
  width: 766,
  marginRight: 6,
}, 'leftColumn')

const RightColumn = styled.div({
  width: 380,
  backgroundColor: 'white',
}, 'rightColumn')

class BottomPanel extends PureComponent {

  close = (toPath) => {
    const { history } = this.props
    history.push({
      pathname: toPath,
    })
  }

  render() {
    return (
      $(Switch,
        $(Route, {
          path: `/:page(persons|faces)/:id`,
          render: props => {
            const { page, id } = props.match.params

            const personId = page === 'persons' ? id : undefined
            const descriptorId = page === 'faces' ? id : undefined
            const type = page === 'persons' ? 'person' : 'face'
            const url = props.match.url

            return (
              $(Switch,
                $(Route, {
                  path: `${url}/verify/person/:target/:limit?`,
                  render: props => {
                    const { target } = props.match.params
                    return (
                      $(VerificationResults, {
                        closeBottomPanel: () => this.close(`/faces/${id}`),
                        descriptorId: id,
                        personId: target
                      })
                    )
                  }
                }),
                $(Route, {
                  path: `${url}/match/:targetType(lists|faces)/:target/:limit?`,
                  render: props => {
                    const { targetType, target, limit } = props.match.params
                    const listId = targetType === 'lists' ? target : undefined
                    const descriptorIds = targetType === 'faces' ? target.split(',') : undefined

                    return (
                      page === 'persons'
                      ? $(MatchingPerson, {
                          closeBottomPanel: () => this.close(`/persons/${id}`),
                          matchType: 'match',
                          type,
                          personId,
                          listId,
                          descriptorIds,
                          limit
                        })
                      : $(MatchingFace, {
                          closeBottomPanel: () => this.close(`/faces/${id}`),
                          matchType: 'match',
                          type,
                          descriptorId,
                          listId,
                          descriptorIds,
                          limit
                        })
                    )
                  }
                }),
                $(Route, {
                  path: `${url}/identify/:targetType(lists|persons)/:target/:limit?`,
                  render: props => {
                    const { targetType, target, limit } = props.match.params
                    const listId = targetType === 'lists' ? target : undefined
                    const personIds = targetType === 'persons' ? target.split(',') : undefined

                    return (
                      page === 'persons'
                      ? $(IdentifyPerson, {
                          closeBottomPanel: () => this.close(`/persons/${id}`),
                          matchType: 'identify',
                          type,
                          personId,
                          listId,
                          personIds,
                          limit
                        })
                      : $(IdentifyFace, {
                          closeBottomPanel: () => this.close(`/faces/${id}`),
                          matchType: 'identify',
                          type,
                          descriptorId,
                          listId,
                          personIds,
                          limit
                        })
                    )
                  }
                }),
              )
            )
          }
        })
      )
    )
  }
}

export const BottomPanelWrapped =  withRouter(BottomPanel)

export class InnerLayout extends PureComponent {

  render() {
    const [header, leftColumn, rightColumn] = this.props.children
    return (
      $(Container,
        $(InnerContainer,
          $(Header, header),
          $(Columns,
            $(LeftColumn, leftColumn),
            $(RightColumn, rightColumn),
          )
        ),
        $(BottomPanelWrapped)
      )
    )
  }
}

export default InnerLayout



// WEBPACK FOOTER //
// ./src/components/InnerLayout.js